import { render, staticRenderFns } from "./ItemSearch.vue?vue&type=template&id=8db87f82&"
import script from "./ItemSearch.vue?vue&type=script&lang=js&"
export * from "./ItemSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports